import React from 'react';
import Banner from '../Banner';
import Header from '../Header';
import Content from './Content';
import './terms.scss';
// import {Container, Row, Col} from 'reactstrap';

class TermsOfService extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    render() {
        return (<div id="termsWrapper">
            <Banner />
            <Header />
            <Content />
        </div>)
    }
}

export default TermsOfService;
